<template>
  <div>
    <div class="boires-page-loader-div" v-if="isLoading">
      <div class="boires-page-loader"></div>
    </div>
    <el-row class="container mb-100">
      <el-col :span="layoutBreakpoint.isMobile ? 24 : 15">
        <h2 class="title text-uppercase text-left pt-60">
          {{ $i18n.t("shoppingCart.shoppingCartView.title") }}
        </h2>
        <ShoppingCartProductsList
          v-if="isCreated && agencyProducts.length > 0"
          id="agency-products"
          class="mt-15"
          :title="
            $i18n.t('shoppingCart.shoppingCartView.agencyProductsSubtitle')
          "
          :products-items="agencyProducts"
          :ProductDefaultPrice="productPrice"
          @emit-remove="removeProduct"
          @emit-quantity-change="modifyProductQuantity"
        />

        <ShoppingCartProductsList
          v-if="isCreated && boutiqueProducts.length > 0"
          id="boutique-products"
          :class="[layoutBreakpoint.isMobile ? 'mt-40' : 'mt-60']"
          :title="
            $i18n.t('shoppingCart.shoppingCartView.boutiqueProductsSubtitle')
          "
          :products-items="boutiqueProducts"
          :ProductDefaultPrice="productPrice"
          @emit-remove="removeProduct"
          @emit-quantity-change="modifyProductQuantity"
          :productType="'boutique'"
        />

        <ShoppingCartProductsList
          v-if="isCreated && reservedProducts.length > 0"
          id="reserved-products"
          :class="[layoutBreakpoint.isMobile ? 'mt-40' : 'mt-60']"
          :title="
            $i18n.t('shoppingCart.shoppingCartView.reservedProductsSubtitle')
          "
          :products-items="reservedProducts"
          :is-reserved="true"
          @emit-remove="removeProduct"
          @emit-quantity-change="modifyProductQuantity"
        />
        
        <ShoppingCartSummary
          v-if="layoutBreakpoint.isMobile && showCartcaculate && isCreated"
          class="mt-60"
          @emit-checkout="checkout"
          :shoppingCart="shoppingCart"
          :cartListProduct="cartListProduct"
          :cartSummaryData = "cartSummaryData"
        />
      </el-col>

      <el-col :span="layoutBreakpoint.isMobile ? 0 : 9" class="pl-40 mt-125">
        <ShoppingCartSummary
          v-if="!layoutBreakpoint.isMobile && showCartcaculate && isCreated"
          @emit-checkout="checkout"
          :shoppingCart="shoppingCart"
          :cartListProduct="cartListProduct"
          :cartSummaryData = "cartSummaryData"
        />
      </el-col>
    </el-row>
    <el-dialog class="cookies province-modal" :visible.sync="showValidationModal" :header="false" width="460px">
      <el-row>
        <el-col class="pl-10">
          <div class="description cookie-model">
            <p v-for="(msg, index) in validationMessages" :key="index" v-html="msg">
            </p>
          </div>
          <div v-if="blockedPuids.length > 0" class="mt-20 text-left">
            <el-button type="primary" @click="removeBlockedProducts">
              {{ $i18n.t("shoppingCart.shoppingCartView.removeUnavailable") }}
            </el-button>
          </div>
        </el-col>
      </el-row>
    </el-dialog>

    <!-- Form -->
    <el-dialog
    :visible.sync="dialogFormVisible"
    width="623px"
      :show-close="false"
    >
      <el-row class="text-uppercase text-left">
        <h3 class="dialog__title">{{ $t("shoppingCart.shoppingCartAuthModel.placeOrder") }}</h3>
      </el-row>
      <el-row class="mt-13">
        <el-col :span="layoutBreakpoint.isMobile ? 24 : 9">
          <h5 class="text-left dialog__subtitle">{{ $t("shoppingCart.shoppingCartAuthModel.guestOrder") }}</h5>
          <div :class="[layoutBreakpoint.isMobile ? 'mt-18 text-left mb-25' : 'mt-18 text-left']">
            <el-button
              type="primary"
              class="button-dimension"
              @click="goTo('/checkout')"
            >
            {{ $t("shoppingCart.shoppingCartAuthModel.continue") }}
            </el-button>
          </div>
        </el-col>
        <el-col :span="layoutBreakpoint.isMobile ? 0 : 2">
          <div class="vertical-line" />
        </el-col>
        <el-col :span="layoutBreakpoint.isMobile ? 24 : 13">
          <h5 class="text-left dialog__subtitle">{{ $t("shoppingCart.shoppingCartAuthModel.register") }}</h5>
          <el-tabs
            v-model="dialogActiveName"
            class="mt-14"
            @tab-click="dialogHandleClick"
          >
            <el-tab-pane :label="$t('shoppingCart.shoppingCartAuthModel.createAccount')" name="register" />
            <el-tab-pane :label="$t('shoppingCart.shoppingCartAuthModel.signIn')" name="authenticate" />
          </el-tabs>
          <div v-show="isAuthenticating">
            <AuthenticateComponent
              :is-modal="true"
              :cta-submit-text="'Continuer'"
              :toggle-reset-fields="authenticationFields"
              :redirect-path="'/checkout'"
              @error="showModalError"
            />
          </div>
          <div v-show="isRegistering">
            <RegisterComponent
              :is-modal="true"
              :cta-submit-text="'Continuer'"
              :toggle-reset-fields="registrationFields"
              :redirect-path="'/checkout'"
              @error="showModalError"
            />
          </div>
        </el-col>
      </el-row>
      <el-row v-if="hasError">
        <el-alert
          title="Erreur lors de l'authentification"
          :description="errorMessage"
          type="error"
          :closable="false"
          :center="false"
        />
      </el-row>
    </el-dialog>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";
import { find, get, isEmpty, map } from "@/utils/lodash";
import layoutUtils from "@/utils/layout-utils";

import AuthenticateComponent from "@/views/user/components/authenticate-form.vue";
import RegisterComponent from "@/views/user/components/register-form.vue";
import ShoppingCartSummary from "./components/shopping-cart-summary.vue";
import ShoppingCartProductsList from "./components/shopping-cart-products-list.vue";
import goTo from "../../mixins/goTo";
import ShoppingCart from "@/api/shopping-cart";
import { reportError } from "@/utils/error-reporter";
import { stockShortfall, isSoldOut } from "@/utils/cart-stock-utils";
export default {
  mixins: [goTo],
  components: {
    ShoppingCartSummary,
    ShoppingCartProductsList,
    AuthenticateComponent,
    RegisterComponent,
  },
  data() {
    return {
      dialogFormVisible: false,
      dialogActiveName: "register",
      isRegistering: true,
      isAuthenticating: false,
      registrationFields: false,
      authenticationFields: false,
      hasError: false,
      errorMessage: "Une erreur est survenue lors de l'authentification",
      isCreated: false,
      showCartcaculate: false,
      cartListProduct: {},
      cartSummaryData: {},
      isLoading: true,
      showValidationModal: false,
      validationMessages: [],
      blockedPuids: [],
      orderEnable: false,
    };
  },
  computed: {
    ...mapState("shoppingCart", ["shoppingCart"]),
    ...mapState("user", ["user"]),
    ...mapState("product", ["products"]),
    ...mapGetters("user", ["isLoggedIn"]),
    ...mapState("configuration", ["actionBar"]),

    countryCode() {
      return this.actionBar.country;
    },
    agencyProductsSubtitle() {
      return "Produits de l'agence";
    },
    boutiqueProductsSubtitle() {
      return "Produits de la boutique";
    },
    reservedProductsSubtitle() {
      return "Réservés";
    },
    agencyProducts() {
      if (!this.isLoggedIn) {
        const guestCartProduct = this.products?.results;
        if (Array.isArray(guestCartProduct)) {
          const filterGuestCart = guestCartProduct.filter(
            (p) =>
              p.puid != null &&
              p.inventory?.code !== "STORE_MTL" &&
              p.inventory?.code !== "STORE_QC" &&
              p.inventory?.code !== "STORE_TORONTO"
          );
          return this.mapProducts(filterGuestCart);
        }
        return []; // Return empty array if no guest cart products
      }

      // Ensure shoppingCart and products are valid
      const shoppingCartProducts = get(this.shoppingCart, "products", []);
      if (!Array.isArray(shoppingCartProducts)) {
        console.warn("Shopping cart products are not defined or invalid.");
        return [];
      }
      // Iterate the actual cart (not the catalog search results) so products that
      // are no longer published still render and can be removed by the customer.
      const agencyCartProducts = shoppingCartProducts.filter((cartProduct) => {
        const code = this.resolveCartProductDetail(cartProduct)?.inventory?.code;
        return (
          cartProduct.puid != null &&
          code !== "STORE_MTL" &&
          code !== "STORE_QC" &&
          code !== "STORE_TORONTO"
        );
      });
      return this.mapCartProducts(agencyCartProducts);
    },
    productPrice() {
      return this.cartSummaryData?.lines?.map(line => {
        const obj = {
          productPrice: line.subTotal ?? 0,
          productId: line.prices?.[0]?.productId ?? null,
          agencyFees: line.taxAmount ?? 0
        }
        return obj
      }) || [];
      // const obj = {
      //     productPrice: line.prices[0]?.price || 0,
      //     productId: line.prices[0]?.productId || null,
      //     agencyFees: line.prices[1]?.price || 0
      //   }
    },
boutiqueProducts() {
  if (!this.isLoggedIn) {
    const guestCartProduct = this.products?.results;
    if (guestCartProduct && Array.isArray(guestCartProduct)) {
      const filterGuestCart = guestCartProduct.filter(
        (p) =>
          p.puid != null &&
          (p.inventory?.code === "STORE_MTL" || p.inventory?.code === "STORE_QC" || p.inventory?.code === "STORE_TORONTO")
      );
      return this.mapProducts(filterGuestCart);
    }
    return []; // Return empty array if no guest cart products
  }

  // Ensure shoppingCart and products are valid
  const shoppingCartProducts = get(this.shoppingCart, "products", []);
  if (!Array.isArray(shoppingCartProducts)) {
    console.warn("Shopping cart products are not defined or invalid.");
    return [];
  }
  const boutiqueCartProducts = shoppingCartProducts.filter((cartProduct) => {
    const code = this.resolveCartProductDetail(cartProduct)?.inventory?.code;
    return (
      cartProduct.puid != null &&
      (code === "STORE_MTL" || code === "STORE_QC" || code === "STORE_TORONTO")
    );
  });
  return this.mapCartProducts(boutiqueCartProducts);
},

    reservedProducts() {
      return [];
    },
    // Lines whose puid the catalogue no longer returns at all — distinct from a
    // line that is merely short on stock.
    unavailablePuids() {
      return [...this.agencyProducts, ...this.boutiqueProducts]
        .filter((item) => item && item.unavailable)
        .map((item) => get(item, "product.puid"))
        .filter(Boolean);
    },
    hasUnavailableProducts() {
      return this.unavailablePuids.length > 0;
    },
    layoutBreakpoint() {
      return layoutUtils.layoutBreakpoint(this.$mq);
    },
  },
  async created() {
  const getProducts = JSON.parse(localStorage.getItem("cartProducts" + this.countryCode));
  const getId = JSON.parse(localStorage.getItem("user"));
  const cartId = localStorage.getItem("x-cart");
  const accessToken = localStorage.getItem('access-token');

  // if ((!getId && !cartId)) {
  //   this.goTo("/shopping-cart-empty");
  //   return;
  // }

  try {
    let puidsToFetch = [];
    
    if (accessToken) {
      if (getId || cartId) {
        // Read and clear the SAME key. This used to merge from
        // `cartProducts<actualCountryCode>` but delete
        // `cartProducts<countryCode>`; logging in sets both from the account's
        // portausCompany, so a guest who filled a cart in one market and signed
        // into an account in the other never had the guest cart cleared — every
        // later visit re-merged the same lines into the server cart.
        // The delete also sat INSIDE the loop, so a failure partway through
        // wiped the remaining un-merged lines.
        const code = localStorage.getItem("actualCountryCode") || this.countryCode;
        const guestCartKey = "cartProducts" + code;
        const getProducts = JSON.parse(localStorage.getItem(guestCartKey));
        if (getProducts) {
          // const puids = getProducts.map(p => p.puid);

          const addProductsToCart = async () => {
              for (const item of getProducts) {
              await this.addProductToShoppingCart({
                  id: getId.id,
                  product: {
                    puid: item.puid,
                    quantity: item.actualQuantity || item.quantity/item.uvc,
                  },
                });
              }
              localStorage.removeItem(guestCartKey);
            };
            addProductsToCart()
              .then(() => this.fetchAndHandleShoppingCart(getId.id))
              .catch(() => this.goTo('/shopping-cart-empty'));
        } else {
          await this.fetchAndHandleShoppingCart(getId.id);
        }
      }
    }
     else {
      if (!getProducts || getProducts.length === 0) {
        this.goTo("/shopping-cart-empty");
        return;
      }
      // 👤 Not logged in, use localStorage only
      puidsToFetch = getProducts.map(p => p.puid).filter(Boolean);
    }

    // Fetch product details and calculate
    if (puidsToFetch.length > 0) {
      await this.fetchProductsByPuid({ puids: puidsToFetch });
      if (this.pruneUnknownGuestProducts(puidsToFetch)) {
        this.goTo("/shopping-cart-empty");
        return;
      }
      await this.getCartCalculation();
    }
  } catch (error) {
    // Bailing to the empty-cart page hides the cause completely — without this
    // report the customer just sees an empty cart and we see nothing at all.
    reportError("CART_FLOW_FAILED", {
      message: error && error.message,
      error,
      data: { stage: "created" },
    });
    this.goTo("/shopping-cart-empty");
}
},
mounted() {
  this.$root.$on("chancountryCode", (countryCode) => {
    if (['/shopping-cart', '/shopping-cart-empty'].includes(this.$route.path))  {
      try {
        const getProducts = JSON.parse(localStorage.getItem("cartProducts" + countryCode));
        if (!getProducts || getProducts.length === 0 || getProducts == null) {
          // this.goTo("/shopping-cart");
          this.goTo("/shopping-cart-empty");
          return;
        }
        let puidsToFetch = [];
        puidsToFetch = getProducts.map(p => p.puid).filter(Boolean);
        if (puidsToFetch.length > 0) {
          this.$router.push('/shopping-cart');
          
          this.fetchProductsByPuid({ puids: puidsToFetch });
          this.getCartCalculation();
  
        }
      } catch(error) {
        reportError("CART_FLOW_FAILED", {
          message: error && error.message,
          error,
          data: { stage: "region-change", region: countryCode },
        });
        this.goTo("/shopping-cart-empty");
      }
    }
    });
},


  watch: {
    products(newProducts) {
      if (!isEmpty(newProducts)) {
        this.updateCartProducts();
      }
    }
  },
  methods: {
    ...mapActions("shoppingCart", ["fetchShoppingCart", "updateShoppingCart", "addProductToShoppingCart", "addProductToShoppingCart"]),
    ...mapActions("product", ["fetchProductsByPuid"]),
    async fetchAndHandleShoppingCart(userId) {
    try {
      await this.fetchShoppingCart({ id: userId });
      const cartProducts = this.shoppingCart.products || [];
      if (cartProducts.length === 0) {
        this.goTo('/shopping-cart-empty');
      } else {
        const puids = cartProducts.map(cartProduct => cartProduct.puid).filter(Boolean);
        if (puids.length === 0) {
          this.goTo('/shopping-cart-empty');
          return;
        }
        await this.fetchProductsByPuid({ puids });
        this.getCartCalculation();
      }
    } catch (error) {
      this.goTo('/shopping-cart-empty');
    }
  },
  updateCartProducts() {
      const cartProducts = this.isLoggedIn ? this.shoppingCart.products : JSON.parse(localStorage.getItem('cartProducts' + this.countryCode));
      // const cartProducts = localStorage.getItem('access-token') ? this.shoppingCart.products : JSON.parse(localStorage.getItem('cartProducts' + this.countryCode));      
      if (cartProducts) {
        this.mappedProducts = this.mapProducts(cartProducts);
      }
    },
    // Resolve a cart line's product details, preferring the live catalog entry
    // (from fetchProductsByPuid) and falling back to the product object embedded
    // in the cart itself when the catalog no longer exposes that puid.
    resolveCartProductDetail(cartProduct) {
      if (!cartProduct || !cartProduct.puid) return null;
      const catalogProduct = find(
        this.products?.results,
        (p) => p.puid === cartProduct.puid
      );
      return catalogProduct || cartProduct.product || null;
    },
    // Map the real cart lines (shoppingCart.products) into rows, flagging any
    // line whose puid is missing from the catalog as `unavailable` so the UI can
    // gray it out and require removal before checkout.
    mapCartProducts(cartProducts) {
      return map(cartProducts, (cartProduct) => {
        if (!cartProduct.puid) return null;
        const catalogProduct = find(
          this.products?.results,
          (p) => p.puid === cartProduct.puid
        );
        const product = catalogProduct || cartProduct.product || null;
        if (!product) return null;
        this.showCartcaculate = true;
        this.cartListProduct = this.products;
        return {
          item: product,
          // The remove button emits `product.puid`. On an unavailable line
          // `product` is the snapshot embedded in the cart, which carries no
          // puid, so the X emitted undefined and removeProduct()'s `if (puid)`
          // guard silently did nothing — the one row the customer was told to
          // remove was the only row that could not be removed. The cart line
          // always knows its own puid, so fall back to it.
          product: { ...product, puid: product.puid || cartProduct.puid },
          puid: cartProduct.puid,
          quantity: cartProduct.quantity,
          unavailable: !catalogProduct,
        };
      }).filter(Boolean);
    },
    mapProducts(cartProducts) {
      const vm = this;
      if (!isEmpty(vm.products)) {
        const productsItems = map(cartProducts, (cartProduct) => {
          this.showCartcaculate = true;
          if (!cartProduct.puid) return null;
          const product = find(vm.products.results, (p) => {
           return p.puid === cartProduct.puid
          });
          this.cartListProduct = vm.products;
          if (product) {
            const matchingQuantity = find(this.shoppingCart?.products, (p) => {
              return p.puid === cartProduct.puid;
            });
            const getCartProduct = JSON.parse(localStorage.getItem("cartProducts" + this.countryCode));
            const pp = find(getCartProduct, (p) => {
              return p.puid === cartProduct.puid;
            })

            return {
              item: cartProduct,
              product,
              quantity: matchingQuantity ? matchingQuantity.quantity : getCartProduct ? pp?.quantity : 1,

            };
          }
          return null;
        }).filter(Boolean);
        return productsItems;
      }
      return [];
    },

    // Walk the calculated lines and flag the ones the warehouse cannot cover.
    // Only genuinely stock-gated products count — see cart-stock-utils.js for why
    // `inStock` alone is the wrong test.
    applyStockIssues(data) {
      const messages = [];
      const blockedPuids = [];
      const catalog = get(this.products, "results") || [];

      map(get(data, "lines") || [], (line) => {
        const puid = line.product?.puid;
        const product = find(catalog, (p) => p.puid === puid);
        if (!product) return;

        const cartProductQty = line.qty;
        if (!stockShortfall(product, cartProductQty)) return;

        const qtyAvailable = get(product, "quantity.inStock");
        reportError("CART_QTY_EXCEEDED", {
          message: `Only ${qtyAvailable} available, ${cartProductQty} requested`,
          data: { puid, qtyAvailable, cartProductQty },
        });

        blockedPuids.push(puid);
        const productName = product.name || line.product?.name || "Product";
        // Sold out is not the same problem as "you asked for more than we have":
        // telling someone to reduce a quantity to zero is a dead end.
        const message = isSoldOut(product)
          ? this.$t("shoppingCart.shoppingCartSummaryComponent.soldOut")
          : this.$t("shoppingCart.shoppingCartSummaryComponent.validation");
        messages.push(
          `<span style="color:#a31c25;font-weight:bold">${productName}</span>: ${message}`
        );
      });

      this.blockedPuids = blockedPuids;
      this.orderEnable = messages.length === 0;
      if (messages.length > 0) {
        this.validationMessages = messages;
        this.showValidationModal = true;
      }
    },
    // The modal used to be a dead end: it named the product and asked the customer
    // to remove it, but offered no way to do so, and `orderEnable` stayed false for
    // the rest of the session. Take the lines out for them, in one pass — calling
    // removeProduct() in a loop would race its own cart writes.
    removeBlockedProducts() {
      const puids = this.blockedPuids.slice();
      if (!puids.length) return;
      this.showValidationModal = false;
      this.validationMessages = [];
      this.blockedPuids = [];

      if (!this.isLoggedIn && !localStorage.getItem("access-token")) {
        const stored = JSON.parse(localStorage.getItem("cartProducts" + this.countryCode)) || [];
        const kept = stored.filter((p) => puids.indexOf(p.puid) === -1);
        if (kept.length === 0) {
          this.$store.dispatch("shoppingCart/emptyShoppingCart");
          localStorage.removeItem("cartProducts" + this.countryCode);
          this.goTo("/shopping-cart-empty");
          return;
        }
        this.$store.dispatch("shoppingCart/updateLocalCartProducts", kept);
        localStorage.setItem("cartProducts" + this.countryCode, JSON.stringify(kept));
        this.isLoading = true;
        this.fetchProductsByPuid({ puids: map(kept, (p) => p.puid) })
          .then(() => {
            this.isLoading = false;
            this.getCartCalculation();
          })
          .catch(() => {
            this.goTo("/shopping-cart-empty");
          });
        return;
      }

      const uId = JSON.parse(localStorage.getItem("user"));
      const cartId = localStorage.getItem("x-cart");
      const cart = { ...this.shoppingCart };
      cart.products = (cart.products || []).filter((p) => puids.indexOf(p.puid) === -1);
      this.isLoading = true;
      this.updateShoppingCart({
        id: uId?.id || cartId,
        shoppingCart: cart,
      })
        .then(() => {
          const cartProducts = get(this.shoppingCart, "products") || [];
          if (isEmpty(cartProducts)) {
            this.goTo("/shopping-cart-empty");
            return;
          }
          this.fetchProductsByPuid({
            puids: map(cartProducts, (cartProduct) => cartProduct.puid).filter(Boolean),
          });
          this.getCartCalculation();
          this.reRender();
        })
        .catch(() => {
          this.isLoading = false;
          this.goTo("/shopping-cart-empty");
        });
    },
    // A guest cart line stores only {puid, quantity, uvc}. When the catalogue stops
    // returning that puid there is no name, price or image to draw, so the row
    // silently disappeared from the list while still counting toward the header
    // badge and still being sent to /calculate — invisible and unremovable. Drop
    // those lines. Returns true when nothing is left.
    pruneUnknownGuestProducts(requestedPuids) {
      const results = get(this.products, "results") || [];
      // Only trust the response when it is complete; a truncated page would look
      // exactly like a catalogue removal and delete products the customer wants.
      const total = get(this.products, "total");
      if (total != null && total !== results.length) return false;

      const known = map(results, (p) => p.puid);
      const missing = requestedPuids.filter((puid) => known.indexOf(puid) === -1);
      if (!missing.length) return false;

      reportError("CART_PRUNED_UNKNOWN_PUID", {
        message: `${missing.length} cart line(s) no longer returned by the catalogue`,
        data: { puid: missing[0], region: this.countryCode },
      });

      const stored = JSON.parse(localStorage.getItem("cartProducts" + this.countryCode)) || [];
      const kept = stored.filter((p) => missing.indexOf(p.puid) === -1);
      this.$store.dispatch("shoppingCart/updateLocalCartProducts", kept);
      localStorage.setItem("cartProducts" + this.countryCode, JSON.stringify(kept));
      return kept.length === 0;
    },
    removeProduct(puid) {
      const uId = JSON.parse(localStorage.getItem("user"));
      const cartId = localStorage.getItem("x-cart");
      if (!this.isLoggedIn && !localStorage.getItem('access-token')) {
        const getLocalstorageProduct = JSON.parse(localStorage.getItem("cartProducts" + this.countryCode));
        let remove = false;
        if (getLocalstorageProduct) {
          for (let i = getLocalstorageProduct.length - 1; i >= 0; i--) {
            if (getLocalstorageProduct[i].puid === puid) {
                      getLocalstorageProduct.splice(i, 1);
                      this.$store.dispatch("shoppingCart/updateLocalCartProducts", getLocalstorageProduct);
                      remove = true;
                  }
          }
        }
        if (remove) {
          if (getLocalstorageProduct.length === 0) {
            this.$store.dispatch('shoppingCart/emptyShoppingCart');
            localStorage.removeItem('cartProducts' + this.countryCode);
            this.goTo("/shopping-cart-empty");
            return;
          }
          localStorage.setItem("cartProducts" + this.countryCode, JSON.stringify(getLocalstorageProduct));
          const puids = map(getLocalstorageProduct, (p) => p.puid)
          this.isLoading = true;
          this.fetchProductsByPuid({
            puids,
          }).then(() => {
            this.isLoading = false;
            this.getCartCalculation();
          }).catch(() => {
            this.goTo("/shopping-cart-empty");
          })
        }        
      } 
      else {
        if (puid) {
          const cart = {
            ...this.shoppingCart,
          };
          cart.products = cart.products.filter((p) =>  p.puid !== puid);
          this.isLoading = true;
          this.updateShoppingCart({
            id: uId?.id || cartId,
            shoppingCart: cart,
          }).then(() => {
            const cartProducts = get(this.shoppingCart, "products");
            const puids = cartProducts.map(cartProduct => cartProduct.puid).filter(Boolean);
            this.fetchProductsByPuid({ puids });
            if (isEmpty(cartProducts)) {
              this.goTo("/shopping-cart-empty");
            }
            this.getCartCalculation();
            this.reRender();
          }).catch((error) => {
            // Bouncing to the empty-cart page on a failed removal reads as
            // success — the customer is shown an empty cart while the line is
            // still on the server, and finds it again on the next visit. Stay
            // put, surface it, and leave the row so they can retry.
            this.isLoading = false;
            reportError("CART_REMOVE_FAILED", {
              message: error && error.message,
              error,
              data: { puid, region: this.countryCode },
            });
          });
        }
      }
    },
    /* eslint-disable object-curly-newline */
    modifyProductQuantity({ puid, quantity }) {
      if (localStorage.getItem('access-token')) {
        const uId = JSON.parse(localStorage.getItem("user"));
        const cartId = localStorage.getItem("x-cart");
        if (puid && quantity) {
          const cart = JSON.parse(JSON.stringify(this.shoppingCart));
          const product = cart.products.find((p) => p.puid === puid);
          product.quantity = quantity;
          this.isLoading = true;
          this.updateShoppingCart({
            id: uId?.id || cartId,
            shoppingCart: cart,
          })
            .then(() => {
              const cartProducts = get(this.shoppingCart, "products");
              if (isEmpty(cartProducts)) {
                this.goTo("/shopping-cart-empty");
              }
  
              const puids = map(cartProducts, (cartProduct) => cartProduct.puid).filter(Boolean);
              this.reRender();
              this.fetchProductsByPuid({
                puids,
              }).then(() => {
                this.getCartCalculation();
              });
            })
            .catch(() => {
              this.isLoading = false;
              this.goTo("/shopping-cart-empty");
            });
  
          this.reRender();
      }
      } else {
        this.getCartCalculation();
      }
    },
    checkout() {
      if (this.hasUnavailableProducts) {
        this.validationMessages = [
          this.$t("shoppingCart.shoppingCartView.unavailableCheckoutBlocked"),
        ];
        // Same one-click removal as the out-of-stock case, so this modal is not a
        // dead end either.
        this.blockedPuids = this.unavailablePuids;
        this.showValidationModal = true;
        return;
      }
      if (!this.orderEnable) {
        // `orderEnable` only flips true once a calculation comes back clean, so it
        // is also false while one is still in flight. Opening an empty modal in
        // that window reads as a broken button.
        if (this.validationMessages.length > 0) {
          this.showValidationModal = true;
        }
        return;
      }
      if (this.isLoggedIn || localStorage.getItem('access-token')) {
        this.goTo("/checkout");
      } else {
        this.dialogFormVisible = true;
      }
    },
    dialogHandleClick() {
      this.toggleAuthenticatingMethod();
    },
    toggleAuthenticatingMethod() {
      this.hasError = false;
      this.isRegistering = this.dialogActiveName === "register";
      this.isAuthenticating = this.dialogActiveName === "authenticate";

      if (this.isAuthenticating) {
        this.resetRegistrationFields();
      } else if (this.isRegistering) {
        this.resetAuthenticationFields();
      }
    },
    resetRegistrationFields() {
      setTimeout(() => {
        this.registrationFields = true;
        setTimeout(() => {
          this.registrationFields = false;
        }, 100);
      }, 100);
    },
    resetAuthenticationFields() {
      setTimeout(() => {
        this.authenticationFields = true;
        setTimeout(() => {
          this.authenticationFields = false;
        }, 100);
      }, 100);
    },
    showModalError(error) {
      this.hasError = true;
      console.log("error", error);
    },
    reRender() {
      this.showCartcaculate = false;
      this.$nextTick(() => {
        this.showCartcaculate = true;
      });
    },
    getCartCalculation() {
      // if (this.isLoggedIn == false) {
        const getCode = localStorage.getItem("countryCode");
        const getLocalstorageProduct = JSON.parse(localStorage.getItem("cartProducts" + getCode));
        if (getLocalstorageProduct) {
          const productItems = map(getLocalstorageProduct, (cartProduct) => {
            return {
              product: {
                puid: cartProduct.puid
              },
              qty: cartProduct.quantity
            };
          }).filter(item => item.product.puid);
          const customerId = localStorage.getItem("x-cart");
          const cart = {
            customer:{
              id: customerId
            },
            lines: productItems
          };
        this.isLoading = true;
        ShoppingCart
          .getCartCalculation(cart)
          .then((data) => {
            if (data) {
              this.applyStockIssues(data);
              this.cartSummaryData = data;
              this.isCreated = true;
              this.reRender();
              this.isLoading = false;
            } else {
              this.isLoading = false;
            }
          })
          .catch(() => {
            this.isLoading = false;
            this.goTo("/shopping-cart-empty");
          });
        }
        const cartProducts = get(this.shoppingCart, "products");
        const productsItems = map(cartProducts, (cartProduct) => {
          var qty = cartProduct.quantity
          return {
            product: {
              puid: cartProduct.puid
            },
            qty: qty
          };
        }).filter(item => item.product.puid);
  
        const customerId = get(this.user, "customer.id",'') || localStorage.getItem("x-cart");
        const cart = {
          customer:{
            id: customerId
          },
          lines: productsItems
        };
        if (productsItems.length > 0) {
          
          ShoppingCart
            .getCartCalculation(cart)
            .then((data) => {
              if (data) {
                this.applyStockIssues(data);
                this.cartSummaryData = data;
                this.isCreated = true;
                this.reRender();
                this.isLoading = false;
              } else {
                this.isLoading = false;
              }
            })
            .catch(() => {
              this.isLoading = false;
              this.goTo("/shopping-cart-empty");
            });
        }
      //  }
      }
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/variables.scss";
.title {
  color: $color-on-background;

  // sm -
  @media screen and (max-width: $media-md) {
    height: 32px;
  }
  // md +
  @media screen and (min-width: $media-md) {
    height: 46px;
  }
}

.dialog__title {
  color: $color-on-background;
  margin-top: -17px;
  height: 32px;
}

.dialog__subtitle {
  color: $color-on-background;
  font-size: 18px !important;
  height: 24px;
}

.vertical-line {
  width: 2px;
  height: 435px;
  background-color: lightgray;
  opacity: 0.5;
}

.button-dimension {
  height: 35px;
  width: 128px;
  font-size: 16px;
}
</style>
